module.exports = __webpack_public_path__ + "img/kava.d5064b94.svg";